import React from 'react';
import { Button, Form, Input, Select, Space, Radio } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { SS } from '@/script/moduleLen.js';

const SsData = () => {
}

SsData.ssUserCode = () => {
    return (
        <Form.Item name="ssUserCode" label="子系统代码" rules={[{ required: true }, { max: SS.ssUserCode }]}>
            <Input size="middle" placeholder="请输入子系统代码" />
        </Form.Item>
    );
}

SsData.ssName = () => {
    return (
        <Form.Item name="ssName" label="子系统名称" rules={[{ required: true }, { max: SS.ssName }]}>
            <Input size="middle" placeholder="请输入子系统名称" />
        </Form.Item>
    );
}

SsData.ssTypeCode = () => {
    return (
        <Form.Item name="ssTypeCode" label="子系统类型" rules={[{ required: true, message: '请选择子系统类型' }]}>
            <Select placeholder="请选择子系统类型">
                <Option value="GS">一般子系统</Option>
                <Option value="UIS">用户界面子系统</Option>
                <Option value="FCS">服务子系统</Option>
            </Select>
        </Form.Item>
    );
}

SsData.isUi = () => {
    return (
        <Form.Item name="isUi" label="子系统类型" initialValue={'0'} rules={[{ required: true, message: '请选择子系统类型' }]}>
            <Select placeholder="请选择子系统类型">
                <Option value="1">界面</Option>
                <Option value="0">服务</Option>
                <Option value="2">程序库</Option>
            </Select>
        </Form.Item>
    );
}

SsData.memo = () => {
    return (
        <Form.Item name="memo" label="备注" rules={[{ max: SS.memo }]}>
            <Input.TextArea placeholder="请输入备注" rows="4" />
        </Form.Item>
    );
}

SsData.SaveButton = ({ onCancel, onSave }) => {
    return (
        <Space>
            <Button size="middle" type="primary" ghost onClick={onCancel}>取消</Button>
            <Button htmlType="submit" type="primary" size="middle" icon={<SaveOutlined />} onClick={onSave}>保存</Button>
        </Space>
    );
}

export default SsData;